/* eslint-disable class-methods-use-this */
import DataConverter from './DataConverter.model';

export interface IProductSpecApiModel {
  id: string;
  specName: string | null;
  specDetail: string | null;
  specGroupId: string;
}
export interface IProductSpecSQLApiModel {
  id: string | null;
  specName: string | null;
  specDetail: string | null;
  specGroupId: string | null;
}
export interface IProductSpec {
  id: string;
  specName: string | null;
  specDetail: string | null;
  specGroupId: string;
}
class ProductSpecConverter extends DataConverter<
  IProductSpecApiModel,
  IProductSpec
> {
  fromApiModel(model: IProductSpecApiModel): IProductSpec {
    return model;
  }

  fromArrayApiModel(model: IProductSpecSQLApiModel[]): IProductSpec[] {
    const cleanNames = model.filter((spec): spec is IProductSpecApiModel => {
      // Valid ones have either name or detail set.
      const nameOrDetail = !!spec.specName || !!spec.specDetail;
      return nameOrDetail;
    });
    return cleanNames.map(this.fromApiModel);
  }
}

export default new ProductSpecConverter();
